import * as React from "react"
import { Link } from "gatsby"
import Logo from "./logo"
import Navigation from "./navigation"

import "./header.scss"

const Header = ({title}) => {


  console.log(title)

  return (
    <header>
      <Link
        to="/"
        activeClassName="active"
        className="logo-link"
      >
        <Logo />
      </Link>
      <div className="nav-wrap">
        <Navigation />
      </div>
    </header>
)}

export default Header
